import { render, staticRenderFns } from "./examDetails.vue?vue&type=template&id=2feef2ac&scoped=true"
import script from "./examDetails.vue?vue&type=script&lang=js"
export * from "./examDetails.vue?vue&type=script&lang=js"
import style0 from "./examDetails.vue?vue&type=style&index=0&id=2feef2ac&prod&lang=scss&scoped=true"
import style1 from "../asset/css/examDetails.scss?vue&type=style&index=1&id=2feef2ac&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feef2ac",
  null
  
)

export default component.exports